import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PayPalComponent } from './components/paypal.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    PayPalComponent
  ],
  exports: [
    PayPalComponent
  ]
})
export class PaypalModule { }
